export default __webpack_public_path__ + "static/media/taesung_crop_resize.b3170633.jpg";